export default __webpack_public_path__ + "static/media/cake26.668f38f5.jpg";